// import './icon.scss';

export { default } from './Icon';
export { default as template } from './icon.tpl';
